import { reactive } from 'vue';

export const snackbar = reactive({
  show: false,
  text: '',
  color: 'info',
  timeout: 5000,
});

export function showSnackbar(
  text: string,
  color: 'success' | 'error' | 'info' | 'warning' = 'info',
) {
  snackbar.text = text;
  snackbar.color = color;
  snackbar.show = true;
}
